<app-centre-small-opener>
    <h2 mat-dialog-title dialogTitle class="title mar-b-5">Video Tour</h2>
    <mat-icon class="close-icon" mat-dialog-close>
      close
  </mat-icon>
    <div contentContainer class="row mat-elevation-z3" [ngStyle]="{'width':'100%', 'margin':'0 auto'}">
        <video width="400" controls>
            <source src="mov_bbb.mp4" type="video/mp4">
            <source src="mov_bbb.ogg" type="video/ogg">
            Your browser does not support HTML video.
        </video>
    </div>
  </app-centre-small-opener>